import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DefaultNavbar from "devComponents/Navbars/PublicNavbar";
import bgVideo from "assets/backgroundAboutUs.mp4";
import logoImage from "assets/devHousePanner.png";
import hazem from "assets/hazem.jpeg"
import Amr from "assets/Amr.jpeg"
import karim from "assets/karim.jpeg"



const teamMembers = [
  {
    id: 1,
    name: "Hazem Bayoumi",
    role: "CEO & Founder",
    image: "Hazem",
  },
  {
    id: 2,
    name: "Amr Hamouda",
    role: "Tech Lead",
    image: Amr,
  },
  {
    id: 3,
    name: "Karim Abd El-Latif",
    role: "Project Manager",
    image: karim,
  },
  {
    id: 4,
    name: "David Smith",
    role: "Lead Developer",
    bio: "Full-stack expert with passion for clean code",
    image: "https://via.placeholder.com/300x300?text=Developer",
  },
  {
    id: 5,
    name: "Jessica Wang",
    role: "Product Manager",
    bio: "Strategic thinker dedicated to customer success",
    image: "https://via.placeholder.com/300x300?text=PM",
  },
  {
    id: 6,
    name: "James Brown",
    role: "Operations Lead",
    bio: "Scaling operations and team growth expert",
    image: "https://via.placeholder.com/300x300?text=Operations",
  },
];

function About() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <video
        autoPlay
        loop
        src={bgVideo}
        muted
        playsInline
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -2,
        }}
      />
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          zIndex: -1,
        }}
      />

      <Box sx={{ position: "relative", zIndex: 2 }}>
        <DefaultNavbar />

        {/* Hero Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            pt: 5,
            pb: { xs: 2, md: 5 },
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: { xs: "2rem", md: "3.5rem" },
              color: "#fff",
              background: "linear-gradient(135deg, #fff, #e0e0e0)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              mb: 1,
            }}
          >
            About TheDevHouse
          </Typography>
          {/* <Typography
            variant="body1"
            sx={{
              maxWidth: 700,
              mx: "auto",
              color: "#fff",
              fontSize: { xs: "1rem", md: "1.1rem" },
              lineHeight: 1.6,
            }}
          >
            Crafting innovative software solutions since 2021
          </Typography> */}
        </Box>

        {/* Company Story Section */}
        <Container maxWidth="lg" sx={{ py: { xs: 0, md: 12 } }}>
          <Grid container spacing={4} alignItems="center" sx={{ mb: 12 }}>
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "1.5rem", md: "2rem" },
                  color: "#fff",
                  mb: 2,
                }}
              >
                Our Story
              </Typography>
              <Typography
                sx={{
                  color: "#e0e0e0",
                  fontSize: { xs: "0.95rem", md: "1rem" },
                  lineHeight: 1.8,
                  mb: 2,
                }}
              >
                We started with a simple mission: to create exceptional digital
                experiences that empower businesses and turn ideas into reality.
                We began operating remotely in 2021, building a strong
                foundation and collaborating across borders.
              </Typography>
              <Typography
                sx={{
                  color: "#e0e0e0",
                  fontSize: { xs: "0.95rem", md: "1rem" },
                  lineHeight: 1.8,
                }}
              >
                In 2023, we established our onsite office in Cairo, Heliopolis,
                bringing our talented team of developers, designers, and
                strategists together under one roof. Today, we are passionate
                about solving complex challenges with elegant, scalable
                solutions.
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  height: 300,
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={logoImage}
                  alt="Company"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Values Section */}
          <Box sx={{ mb: 12 }}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: { xs: "1.5rem", md: "2rem" },
                color: "#fff",
                mb: 6,
                textAlign: "center",
              }}
            >
              Our Values
            </Typography>
            <Grid container spacing={4}>
              {[
                {
                  title: "Innovation",
                  description:
                    "We constantly push boundaries to create cutting-edge solutions",
                },
                {
                  title: "Quality",
                  description:
                    "Excellence is not an act, it is a habit in everything we do",
                },
                {
                  title: "Collaboration",
                  description:
                    "We believe the best ideas come from diverse perspectives",
                },
                {
                  title: "Integrity",
                  description:
                    "Trust and transparency form the foundation of our relationships",
                },
              ].map((value, index) => (
                <Grid item xs={12} md={6} key={index}>
                  <Card
                    sx={{
                      backgroundColor: "rgba(255, 255, 255, 0.05)",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      p: 4,
                      height: "100%",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                        transform: "translateY(-5px)",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "1.3rem",
                        color: "#fff",
                        mb: 1,
                      }}
                    >
                      {value.title}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#c0c0c0",
                        fontSize: "0.95rem",
                        lineHeight: 1.6,
                      }}
                    >
                      {value.description}
                    </Typography>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Team Section
          <Box sx={{ mb: 12 }}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: { xs: "1.5rem", md: "2rem" },
                color: "#fff",
                mb: 6,
                textAlign: "center",
              }}
            >
              Meet Our Team
            </Typography>
            <Grid container spacing={4}>
              {teamMembers.map((member) => (
                <Grid item xs={12} sm={6} md={4} key={member.id}>
                  <Card
                    sx={{
                      backgroundColor: "rgba(255, 255, 255, 0.05)",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      overflow: "hidden",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                        transform: "translateY(-10px)",
                      },
                    }}
                  >
                    <Box
                      component="img"
                      src={member.image}
                      alt={member.name}
                      sx={{
                        width: "100%",
                        height: 400,
                        objectFit: "cover",
                      }}
                    />
                    <Box sx={{ p: 3 }}>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "1.1rem",
                          color: "#fff",
                          mb: 0.5,
                        }}
                      >
                        {member.name}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.85rem",
                          color: "#64b5f6",
                          mb: 1.5,
                          fontWeight: 500,
                        }}
                      >
                        {member.role}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#c0c0c0",
                          fontSize: "0.9rem",
                          lineHeight: 1.5,
                        }}
                      >
                        {member.bio}
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box> */}
        </Container>

        {/* CTA Section */}
        <Box
          sx={{
            py: 12,
            textAlign: "center",
            background:
              "linear-gradient(135deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.09))",
            }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: { xs: "1.5rem", md: "2rem" },
              color: "#fff",
              mb: 3,
            }}
          >
            Ready to Work With Us?
          </Typography>
          <Typography
            sx={{
              color: "#c0c0c0",
              fontSize: "1rem",
              mb: 4,
              maxWidth: 600,
              mx: "auto",
            }}
          >
            Let's collaborate to build something amazing for your business
          </Typography>
          <Box
            component="a"
            href="/ContactUs"
            sx={{
              display: "inline-block",
              px: 4,
              py: 1.5,
              backgroundColor: "#329df6ff",
              color: "#ffffffff",
              textDecoration: "none",
              borderRadius: 1,
              fontWeight: 600,
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "#42a5f5",
                transform: "scale(1.05)",
              },
            }}
          >
            Get in Touch
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default About;
